module.exports = __webpack_public_path__ + "static/media/howitworks1.569f5232.png";